import { Textarea } from './textarea.component';

export * from './textarea.component';
export default Textarea;

Textarea.define('der-ui-textarea');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-textarea': Textarea;
    }
}
